import Box from '@mui/material/Box';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import React from 'react';
import Swiper from '../../../Swiper/Swiper';
import { withBaseComponent } from '../../hoc/withBaseComponent';

/**
 * @param {object} props
 * @param {object} props.blok
 * @param {object} props.baseStyles
 */
const StoryblokCarousel = ({ blok, baseStyles }) => {
  const {
    general = {
      items: [],
      autoplay: true,
      pagination: true,
      navigation: true,
      count: '3',
      loop: false,
    },
    extra = { id: '' },
  } = blok;
  const { items, autoplay, pagination, navigation, slidesToScroll, count, loop } = general;
  const { id } = extra;

  return (
    <Box
      {...storyblokEditable(blok)}
      id={id}
      key={blok._uid}
      sx={{ width: '100%', position: 'relative', ...baseStyles }}
    >
      <Swiper
        accessibility={navigation}
        arrows={navigation}
        autoplay={autoplay}
        dots={pagination}
        infinite={loop}
        slidesToScroll={parseInt(slidesToScroll)}
        slidesToShow={parseInt(count)}
      >
        {items.map((nestedBlok, index) => (
          <Box
            key={index}
            sx={{
              p: 1,
            }}
          >
            <StoryblokComponent blok={nestedBlok} />
          </Box>
        ))}
      </Swiper>
    </Box>
  );
};

export default withBaseComponent(StoryblokCarousel);
